import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Collaborateur, Partenaire } from '../../shared/model';
import { DatabaseConnection } from '../../shared/services/database-connection';


@Injectable({
  providedIn: 'root',
})
export class CollaborateurService {

  end_url = 'collaborateur'

  constructor(private http : HttpClient, private  dbConnection : DatabaseConnection){}

  getAll(){
    return this.http.get<Collaborateur[]>(this.dbConnection.remoteApiConnection.value + this.end_url + '/create')
  }

  get(collaborateur_id : string){
    return this.http.get<Collaborateur>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + collaborateur_id)
  }

  create(data : FormData){
    return this.http.post<Collaborateur>(this.dbConnection.remoteApiConnection.value + this.end_url, data)
  }

  update(data : FormData, id : string){
    return this.http.post<Collaborateur>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id, data)
  }

  delete(id : string){
    return this.http.delete(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id)
  }

  changeStatus(id : string){
    return this.http.get<Collaborateur>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id + '/edit')
  }

  getCollaborateurListEnable(){
    return this.http.get<Partenaire[]>(this.dbConnection.remoteApiConnection.value + 'collaborateur-list-enable')
  }

  getCollaborateurDistribution(collaborateur_id : string){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + 'collaborateur-distribution/'+collaborateur_id)
  }

  getCollaborateurSite(collaborateur_id : string){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + 'collaborateur-site/'+collaborateur_id)
  }

  getCollaborateurUser(collaborateur_id : string){
    return this.http.get<any[]>(this.dbConnection.remoteApiConnection.value + 'collaborateur-user/'+collaborateur_id)
  }

  checkValues(key : string, value : string){
    return new Promise<boolean>((resolve, reject) => {
      this.http.get<boolean>(this.dbConnection.remoteApiConnection.value + 'partenaire' + '?key='+key+'&value='+value).subscribe({
        next : (res) => resolve(res),
        error : (err) => reject("une erreur est surevenue lors de la verification de l'existance de la valeur")
      })
    })
  }

}
